import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-term-condition-page',
  templateUrl: './term-condition-page.component.html',
  styleUrls: ['./term-condition-page.component.css']
})
export class TermConditionPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
